import { Fragment, React, useEffect, useState } from "react";
import { Lock, ToggleRight, X } from "react-feather";
import TopNavStyles from "./styles.jsx";

import { Menu, Transition } from "@headlessui/react";
import { Menu as MenuIcon } from "react-feather";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../../redux/actions/auth";

const TopNav = ({ page, user, setShowSidebar, showSidebar }) => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    window.location = "/";
  };

  const handleCurrentPageTitle = (str) => {
    if (str !== "/") {
      return str?.split("/")[1]?.replace(/[\/-]/g, " ");
    } else {
      return "Dashboard";
    }
  };

  useEffect(() => {
    const sideNavElement = document.querySelector(".side-nav");
    if (sideNavElement) {
      if (showSidebar) {
        sideNavElement.classList.add("show");
      } else {
        sideNavElement.classList.remove("show");
      }
    }

    return () => {
      const sideNavElement = document.querySelector(".side-nav");
      if (sideNavElement) {
        sideNavElement.classList.remove("show");
      }
    };
  }, [showSidebar]);

  return (
    <TopNavStyles>
      <div
        style={{
          zIndex: 2,
        }}
        className="flex items-center gap-[156px]"
      >
        <div className="flex items-center gap-4">
          <button
            onClick={() => {
              setShowSidebar(!showSidebar);
            }}
            className="md:hidden block"
          >
            {showSidebar ? <X /> : <MenuIcon />}
          </button>
          <h1 className=" text-xl font-bold text-theme-32">Instaant</h1>
        </div>

        <h2 className="md:block hidden text-xl font-bold capitalize text-black">
          {handleCurrentPageTitle(page)}
        </h2>
      </div>
      {/* <div className="breadcrumb">
        <a href="/">Application </a>{" "}
        <ChevronRight className="breadcrumb-icon" />
        <a href="#" className="breadcrumb--active">
          {page}
        </a>
      </div> */}

      <div className="flex items-center gap-2">
        <Menu as="div" className="relative flex gap-6 text-left">
          <div>
            <Menu.Button className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EFF0F4] overflow-hidden  image-fit zoom-in">
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.15591 1.51608C4.37935 0.765644 5.03468 0 6.00536 0C6.97629 0 7.63098 0.765676 7.85612 1.51469C7.85724 1.51609 7.85876 1.51785 7.8607 1.51988C7.86531 1.52469 7.87054 1.52912 7.87549 1.53255C7.87925 1.53516 7.88152 1.53629 7.88178 1.53642C8.44683 1.76907 9.11191 2.14069 9.63209 2.82107C10.1565 3.50693 10.4976 4.45903 10.4976 5.78736C10.4976 7.11176 10.6373 7.83802 10.843 8.33659C11.0235 8.77374 11.2607 9.06109 11.5983 9.46999C11.6476 9.52971 11.699 9.59202 11.7528 9.65777L11.7529 9.65793C12.3751 10.4201 11.7876 11.4904 10.8292 11.4904H8.50328C8.50328 12.1529 8.2401 12.7883 7.77166 13.2567C7.30321 13.7252 6.66785 13.9883 6.00536 13.9883C5.34287 13.9883 4.70752 13.7252 4.23907 13.2567C3.77062 12.7883 3.50745 12.1529 3.50745 11.4904H1.1847C0.228051 11.4904 -0.369368 10.4255 0.257964 9.65777C0.311726 9.59197 0.363209 9.52962 0.412549 9.46985C0.750084 9.06103 0.987357 8.77364 1.16793 8.33646C1.37388 7.83784 1.51395 7.11159 1.51473 5.78736M4.50661 11.4904C4.50661 11.8879 4.66452 12.2691 4.94559 12.5502C5.22666 12.8313 5.60787 12.9892 6.00536 12.9892C6.40285 12.9892 6.78407 12.8313 7.06514 12.5502C7.34621 12.2691 7.50411 11.8879 7.50411 11.4904H4.50661ZM1.1847 10.4912C1.08202 10.4912 1.03579 10.444 1.01722 10.4076C1.00653 10.3867 1.00333 10.3663 1.00486 10.3493C1.00623 10.3343 1.01179 10.3143 1.03168 10.29L1.0317 10.29C1.07996 10.2309 1.12857 10.1723 1.17723 10.1137C1.51212 9.71006 1.84964 9.30328 2.09142 8.71791C2.36935 8.04504 2.5131 7.16879 2.5139 5.78765V5.78736C2.5139 4.63659 2.80519 3.9088 3.17344 3.42729C3.54581 2.9404 4.03371 2.65687 4.51095 2.46033C4.51098 2.46031 4.51102 2.4603 4.51106 2.46028C4.76542 2.35565 5.01921 2.12255 5.11087 1.81023L5.11124 1.80898C5.25339 1.31991 5.62073 0.999166 6.00536 0.999166C6.39001 0.999166 6.75746 1.31967 6.90146 1.80976L6.90183 1.81103C6.99295 2.11814 7.24406 2.35451 7.50127 2.4603C7.9775 2.65636 8.46562 2.94044 8.83833 3.42793C9.20689 3.91001 9.49839 4.63806 9.49839 5.78736C9.49839 7.16851 9.64171 8.04482 9.91944 8.71777C10.1611 9.30327 10.4987 9.71012 10.8336 10.1138C10.8822 10.1724 10.9308 10.2309 10.979 10.29C11.0103 10.3284 11.0128 10.3682 10.9925 10.4082C10.9736 10.4456 10.9281 10.4912 10.8292 10.4912H1.1847ZM4.15591 1.51608C4.15504 1.5171 4.15396 1.51831 4.15265 1.51968C4.14839 1.52409 4.14336 1.52834 4.13835 1.5318C4.1337 1.535 4.1309 1.53625 4.1309 1.53626L4.1306 1.53638C3.56531 1.76917 2.9 2.14009 2.37978 2.82031C1.85545 3.5059 1.51478 4.45787 1.51473 5.78707"
                  fill="black"
                />
              </svg>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-theme-26 dark:bg-dark-6 text-white">
              <div className="py-1">
                <Menu.Item>
                  <div className="p-4 border-b border-theme-27 dark:border-dark-3">
                    <div className="font-medium">
                      {user.lastname} {user.firstname}
                    </div>
                    <div className="text-xs text-theme-28 mt-0.5 dark:text-gray-600">
                      {user.msisdn}
                    </div>
                  </div>
                </Menu.Item>

                <Menu.Item>
                  <Link to="/settings">
                    <div className="px-2 border-theme-27 dark:border-dark-3 cursor-pointer">
                      <div className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md">
                        <Lock className="px-1" />
                        Manage Account
                      </div>
                    </div>
                  </Link>
                </Menu.Item>

                <Menu.Item>
                  <div
                    onClick={handleLogout}
                    className="p-2 border-t border-theme-27 dark:border-dark-3 cursor-pointer"
                  >
                    <div className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md">
                      <ToggleRight className="px-1" /> Logout
                    </div>
                  </div>
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
        <Menu as="div" className="relative flex gap-6 text-left">
          <div>
            <Menu.Button className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EFF0F4] overflow-hidden image-fit zoom-in">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="5" cy="1" r="1" fill="black" />
                <circle cx="5" cy="5" r="1" fill="black" />
                <circle cx="5" cy="9" r="1" fill="black" />
                <circle cx="1" cy="1" r="1" fill="black" />
                <circle cx="1" cy="5" r="1" fill="black" />
                <circle cx="1" cy="9" r="1" fill="black" />
                <circle cx="9" cy="1" r="1" fill="black" />
                <circle cx="9" cy="5" r="1" fill="black" />
                <circle cx="9" cy="9" r="1" fill="black" />
              </svg>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-theme-26 dark:bg-dark-6 text-white">
              <div className="py-1">
                <Menu.Item>
                  <div className="p-4 border-b border-theme-27 dark:border-dark-3">
                    <div className="font-medium">
                      {user.lastname} {user.firstname}
                    </div>
                    <div className="text-xs text-theme-28 mt-0.5 dark:text-gray-600">
                      {user.msisdn}
                    </div>
                  </div>
                </Menu.Item>

                <Menu.Item>
                  <Link to="/settings">
                    <div className="px-2 border-theme-27 dark:border-dark-3 cursor-pointer">
                      <div className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md">
                        <Lock className="px-1" />
                        Manage Account
                      </div>
                    </div>
                  </Link>
                </Menu.Item>
                {/*<Menu.Item>*/}
                {/*  <div className="px-2 border-theme-27 dark:border-dark-3 cursor-pointer">*/}
                {/*    <div*/}
                {/*      className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md">*/}
                {/*      <HelpCircle className="px-1"/> Help*/}
                {/*    </div>*/}
                {/*  </div>*/}
                {/*</Menu.Item>*/}

                {/*<Menu.Item>*/}
                {/*  <div className="px-2  border-theme-27 dark:border-dark-3 cursor-pointer">*/}
                {/*    <div*/}
                {/*      className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md">*/}
                {/*      <UserPlus className="px-1"/> Add Account*/}
                {/*    </div>*/}
                {/*  </div>*/}
                {/*</Menu.Item>*/}

                <Menu.Item>
                  <div
                    onClick={handleLogout}
                    className="p-2 border-t border-theme-27 dark:border-dark-3 cursor-pointer"
                  >
                    <div className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md">
                      <ToggleRight className="px-1" /> Logout
                    </div>
                  </div>
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </TopNavStyles>
  );
};

export default TopNav;
